"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChargingStationIcon = ChargingStationIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ChargingStationIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.3821 7.62072H16V4.31035C16 3.62069 15.7549 3 15 3C14.3137 3 14 3.55173 14 4.31035C14 5.06898 14 7.62072 14 7.62072H10.0097V4.31035C10.0097 3.62069 9.75489 3 9 3C8.24511 3 8 3.55173 8 4.31035V7.62072H5.61764C5.27451 7.62072 5 7.89658 5 8.24141V13.3793C5 15.7932 7.49342 17.7931 9.68958 18.4827V22.5172C9.68958 22.7931 9.89546 23 10.17 23H13.83C14.1045 23 14.3104 22.7931 14.3104 22.5172V18.4827C16.5065 17.7931 19 15.793 19 13.3793V8.24141C18.9314 7.89658 18.7253 7.62072 18.3821 7.62072Z",
    fill: "currentColor"
  }));
}